export default {
  thousandSeparator: ' ',
  allowNegative: false,
  decimalScale: 0,
  pattern: '[\\d*\\s*]*'
};
